'use strict';

class AdminApi {
  constructor(apiClient) { this.api = apiClient; }
  users(page, pageSize, query) {
    const params = new URLSearchParams({ page, pageSize, query: query || '' });
    return this.api.request(`/api/admin/users?${params}`);
  }
  user(id) { return this.api.request(`/api/admin/users/${id}`); }
  setUserStatus(id, status) {
    return this.api.request(`/api/admin/users/${id}/status`, { method: 'PATCH', body: { status } });
  }
  draft() { return this.api.request('/api/admin/game-config/draft'); }
  saveDraft(config) {
    return this.api.request('/api/admin/game-config/draft', { method: 'PUT', body: { config } });
  }
  publish() { return this.api.request('/api/admin/game-config/publish', { method: 'POST', body: {} }); }
  versions(page, pageSize) {
    return this.api.request(`/api/admin/game-config/versions?page=${page}&pageSize=${pageSize}`);
  }
  version(id) { return this.api.request(`/api/admin/game-config/versions/${id}`); }
  dashboard() { return this.api.request('/api/admin/dashboard'); }
  leaderboard(type, period, query, page, pageSize) {
    const params = new URLSearchParams({ type, query: query || '', page, pageSize });
    if (period && type !== 'ALL_TIME') params.set('period', period);
    return this.api.request(`/api/admin/leaderboards?${params}`);
  }
  run(id) { return this.api.request(`/api/admin/runs/${id}`); }
  invalidateRun(id, reason) {
    return this.api.request(`/api/admin/runs/${id}/invalidate`, { method: 'POST', body: { reason } });
  }
  restoreRun(id) {
    return this.api.request(`/api/admin/runs/${id}/restore`, { method: 'POST', body: {} });
  }
}

module.exports = AdminApi;
